import { render, staticRenderFns } from "./onlineBianti.vue?vue&type=template&id=13408f06&scoped=true&"
import script from "./onlineBianti.vue?vue&type=script&lang=js&"
export * from "./onlineBianti.vue?vue&type=script&lang=js&"
import style0 from "./onlineBianti.vue?vue&type=style&index=0&id=13408f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13408f06",
  null
  
)

export default component.exports